var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteralLoose(['\n  background: transparent;\n  border: 0;\n  color: ', ';\n  line-height: 1;\n  padding: 0;\n  transition: color 0.2s ease-in-out;\n  text-shadow: 0 0 1px #000;\n\n  &:hover {\n    color: \'#d23823\';\n  }\n\n  &:focus {\n    outline: 0;\n  }\n'], ['\n  background: transparent;\n  border: 0;\n  color: ', ';\n  line-height: 1;\n  padding: 0;\n  transition: color 0.2s ease-in-out;\n  text-shadow: 0 0 1px #000;\n\n  &:hover {\n    color: \'#d23823\';\n  }\n\n  &:focus {\n    outline: 0;\n  }\n']);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styled from 'styled-components';

var Button = styled('button')(_templateObject, function (props) {
  return props.active ? '#d23823' : '#fff';
});

export var SmallFollowButton = function (_React$Component) {
  _inherits(SmallFollowButton, _React$Component);

  function SmallFollowButton() {
    var _temp, _this, _ret;

    _classCallCheck(this, SmallFollowButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.authAndFollow = function () {
      var _this$props = _this.props,
          _auth = _this$props._auth,
          location = _this$props.location,
          merchant = _this$props.merchant;


      _this.props._afterAuth.updateActions({
        callbacks: [{
          action: 'follow',
          args: _this.props.merchant
        }],
        redirect: _this.props.location.pathname.substring(1),
        scrollTo: window.pageYOffset
      });

      _this.props._auth.authRedirect('login');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  SmallFollowButton.prototype.render = function render() {
    var _props = this.props,
        auth = _props.auth,
        merchant = _props.merchant,
        onClick = _props.onClick;


    return React.createElement(
      Button,
      _extends({}, this.props, {
        active: merchant.followed,
        onClick: auth.get('user').get('isLoggedIn') ? onClick : this.authAndFollow
      }),
      React.createElement('i', {
        className: classNames('fa', {
          'fa-heart-o': !merchant.followed,
          'fa-heart': merchant.followed
        }),
        'aria-label': merchant.followed ? 'Following' : 'Follow'
      })
    );
  };

  return SmallFollowButton;
}(React.Component);

SmallFollowButton.PropTypes = {
  auth: PropTypes.object.isRequired,
  merchant: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
};


//////////////////
// WEBPACK FOOTER
// ../ui-components/es/SmallFollowButton.js
// module id = 365
// module chunks = 4